import React, { useCallback, useEffect, useState } from "react";
import api from "../../setupAxios";
import { useDialog } from "../../context/dialogContext";
import { fechaLarga, hoyISO, msgError } from "../../utils";

const SEMANA = [["1", "L"], ["2", "M"], ["3", "X"], ["4", "J"], ["5", "V"], ["6", "S"], ["0", "D"]];

// Todas las fechas entre `desde` y `hasta` cuyo día de la semana esté marcado.
function fechasDelRango(desde, hasta, dias) {
  const out = [];
  for (let d = new Date(`${desde}T00:00:00`); d <= new Date(`${hasta}T00:00:00`) && out.length < 400; d.setDate(d.getDate() + 1)) {
    if (dias.includes(String(d.getDay()))) {
      out.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`);
    }
  }
  return out;
}

export default function TabFranjas() {
  const { avisar, confirmar, confirmarPeligro, exito } = useDialog();
  const [franjas, setFranjas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [desde, setDesde] = useState(hoyISO());
  const [hasta, setHasta] = useState(hoyISO());
  const [dias, setDias] = useState(["1", "2", "3", "4", "5"]);
  const [horas, setHoras] = useState([{ inicio: "09:00", fin: "10:00", aforo: 20 }]);
  const [soloFuturas, setSoloFuturas] = useState(true);

  const cargar = useCallback(async () => {
    try { const { data } = await api.get("/admin/franjas"); setFranjas(data.franjas); }
    catch (e) { avisar(msgError(e)); }
    setCargando(false);
  }, [avisar]);
  useEffect(() => { cargar(); }, [cargar]);

  const fechas = desde && hasta && desde <= hasta ? fechasDelRango(desde, hasta, dias) : [];
  const total = fechas.length * horas.length;
  const setHora = (i, k, v) => setHoras(horas.map((h, j) => (j === i ? { ...h, [k]: v } : h)));

  const crear = async () => {
    if (!(await confirmar(`Se crearán hasta ${total} franjas (${fechas.length} días × ${horas.length} horarios). Las que ya existan se respetan. ¿Continuar?`))) return;
    try {
      const { data } = await api.post("/admin/franjas/lote", { fechas, horas: horas.map((h) => ({ ...h, aforo: +h.aforo })) });
      exito(`${data.creadas} franjas creadas${data.ya_existian ? ` (${data.ya_existian} ya existían)` : ""}`);
      cargar();
    } catch (e) { avisar(msgError(e)); }
  };
  const editar = async (f, cambios) => {
    try { await api.put(`/admin/franjas/${f.id}`, cambios); cargar(); } catch (e) { avisar(msgError(e)); cargar(); }
  };
  const borrar = async (f) => {
    if (!(await confirmarPeligro(`¿Borrar la franja del ${fechaLarga(f.fecha)} ${f.hora_inicio}?`, { titulo: "Borrar franja", boton: "Borrar" }))) return;
    try { await api.delete(`/admin/franjas/${f.id}`); cargar(); } catch (e) { avisar(msgError(e)); }
  };

  const visibles = soloFuturas ? franjas.filter((f) => f.fecha >= hoyISO()) : franjas;

  return (
    <div>
      <div className="card">
        <h3>➕ Crear franjas</h3>
        <div className="row">
          <div className="field"><label>Desde</label><input type="date" value={desde} onChange={(e) => setDesde(e.target.value)} /></div>
          <div className="field"><label>Hasta</label><input type="date" value={hasta} min={desde} onChange={(e) => setHasta(e.target.value)} /></div>
        </div>
        <div className="field"><label>Días de la semana</label>
          <div className="ci-dias">
            {SEMANA.map(([v, t]) => (
              <label key={v}><input type="checkbox" checked={dias.includes(v)} onChange={(e) => setDias(e.target.checked ? [...dias, v] : dias.filter((x) => x !== v))} />{t}</label>
            ))}
          </div></div>
        <label className="ci-etiqueta">Horarios (hora inicio · hora fin · aforo máximo)</label>
        {horas.map((h, i) => (
          <div className="ci-lote-horas" key={i}>
            <input type="time" value={h.inicio} onChange={(e) => setHora(i, "inicio", e.target.value)} />
            <input type="time" value={h.fin} onChange={(e) => setHora(i, "fin", e.target.value)} />
            <input type="number" min={1} max={1000} value={h.aforo} onChange={(e) => setHora(i, "aforo", e.target.value)} />
            <button className="btn btn-mini" disabled={horas.length === 1} onClick={() => setHoras(horas.filter((_, j) => j !== i))}>✕</button>
          </div>
        ))}
        <div className="modal-actions" style={{ justifyContent: "flex-start" }}>
          <button className="btn" onClick={() => setHoras([...horas, { inicio: "", fin: "", aforo: 20 }])}>+ Otro horario</button>
          <button className="btn btn-primary" disabled={!total || horas.some((h) => !h.inicio || !h.fin || !(+h.aforo > 0))} onClick={crear}>
            Crear {total} franja{total === 1 ? "" : "s"}
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-headrow">
          <h3>📅 Franjas <span className="count">{visibles.length}</span></h3>
          <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13 }}>
            <input type="checkbox" style={{ width: "auto" }} checked={soloFuturas} onChange={(e) => setSoloFuturas(e.target.checked)} /> Solo desde hoy
          </label>
        </div>
        <div className="tablewrap">
          <table className="ci-tabla t-franjas">
            <thead><tr><th>Día</th><th>Hora</th><th>Aforo</th><th>Apuntados</th><th>Activa</th><th /></tr></thead>
            <tbody>
              {cargando && <tr><td colSpan={6} className="empty">Cargando…</td></tr>}
              {!cargando && visibles.length === 0 && <tr><td colSpan={6} className="empty">No hay franjas.</td></tr>}
              {visibles.map((f) => (
                <tr key={f.id}>
                  <td className="strong">{fechaLarga(f.fecha)}</td>
                  <td>{f.hora_inicio}–{f.hora_fin}</td>
                  <td style={{ width: 90 }}>
                    <input type="number" min={Math.max(1, f.ocupadas)} defaultValue={f.aforo} key={`${f.id}-${f.aforo}`}
                           onBlur={(e) => +e.target.value !== f.aforo && editar(f, { aforo: +e.target.value })} />
                  </td>
                  <td><span className={`badge ${f.ocupadas >= f.aforo ? "badge-red" : f.ocupadas ? "badge-amber" : "badge-gray"}`}>{f.ocupadas}/{f.aforo}</span></td>
                  <td><button className={`btn btn-mini ${f.activa ? "btn-success" : ""}`} onClick={() => editar(f, { activa: !f.activa })}>{f.activa ? "Activa" : "Inactiva"}</button></td>
                  <td><button className="btn btn-mini btn-danger" onClick={() => borrar(f)}>🗑</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
